const initialState = {
  loading: false,
  allStrategy: [],
  selectedHeuristic: null,
};

const strategyReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "LOADING_STRATEGY": {
      return {
        ...state,
        loading: actions.loading,
      };
    }
    case "GET_STRATEGY_DATA": {
      return {
        ...state,
        loading: actions.loading,
        allStrategy: actions.data,
        selectedHeuristic: actions.id,
      };
    }
    case "CLEAR_DATA": {
      return {
        ...state,
        allStrategy: [],
        selectedHeuristic: null,
      };
    }
    //   case "UPDATE_EVENT": {
    //     return { ...state, events: actions.data };
    //   }
    //   case "GET_EVENT_GROUPS": {
    //     return { ...state, eventGroup: actions.data };
    //   }
    //   case "SET_SELECTED_EVENT": {
    //     return { ...state, selectedEvent: actions.data };
    //   }
    //   case "CLEAR_EVENT": {
    //     return { ...state, selectedEvent: [] };
    //   }
    default:
      return state;
  }
};
export default strategyReducer;
